module.exports = __webpack_public_path__ + "static/img/ecological_institute_cooperation_jxlg.4b21aba.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ecological/ecological_institute_cooperation_jxlg.png
// module id = VCaf
// module chunks = 0